import { Injectable } from "@angular/core";
import { Constants } from "../../shared/Constants";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { IWorkOrder } from "../work-order/new-work-order/new-work-order.component";
import { IInternalWorkOrder } from "../work-order/internal-work-order/internal-work-order.component";

@Injectable()
export class WorkOrderService {
  constructor(private http: HttpClient) {}

  getAllWorkOrders(tipo) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );

    return this.http.get(Constants.URL_BACKEND + "/work-order-" + tipo, {
      headers: headers,
    });
  }

  getArchivedWorkOrders(type) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );

    return this.http.get(
      Constants.URL_BACKEND + "/work-order/archived-" + type,
      {
        headers: headers,
      }
    );
  }

  archivarMultiple(updateData: IWorkOrder) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );

    return this.http.put(
      Constants.URL_BACKEND + "/archivarMultiple/work-order",
      { data: updateData },
      { headers: headers }
    );
  }

  getProjects() {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );

    return this.http.get(Constants.URL_BACKEND + "/projects/", {
      headers: headers,
    });
  }

  insertProject(data) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );

    return this.http.post(Constants.URL_BACKEND + "/projects/", data, {
      headers: headers,
    });
  }

  getWorkOrder(id) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );

    return this.http.get(Constants.URL_BACKEND + "/work-order/" + id, {
      headers: headers,
    });
  }
  createWorkOrder(insertData: IWorkOrder) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );

    return this.http.post(
      Constants.URL_BACKEND + "/work-order",
      { data: insertData },
      { headers: headers }
    );
  }
  updateWorkOrder(updateData: IWorkOrder) {
    console.log(updateData);
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );

    return this.http.put(
      Constants.URL_BACKEND + "/work-order/" + updateData.id,
      { data: updateData },
      { headers: headers }
    );
  }

  deleteWorkOrder(id) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );

    return this.http.delete(Constants.URL_BACKEND + "/work-order/" + id, {
      headers: headers,
    });
  }
  getInternalWorkOrder(id) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );

    return this.http.get(Constants.URL_BACKEND + "/internal-work-order/" + id, {
      headers: headers,
    });
  }
  createInternalWorkOrder(insertData: IInternalWorkOrder) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );

    return this.http.post(
      Constants.URL_BACKEND + "/internal-work-order",
      { data: insertData },
      { headers: headers }
    );
  }
  updateInternalWorkOrder(updateData: IInternalWorkOrder, idWorkOrder) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );
    return this.http.put(
      Constants.URL_BACKEND + "/internal-work-order/" + idWorkOrder,
      { data: updateData },
      { headers: headers }
    );
  }
  getInternalOrdersByWorkOrder(id) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );
    return this.http.get(
      Constants.URL_BACKEND + "/internal-work-order/FindByWorkOrder/" + id,
      { headers: headers }
    );
  }
  getAttachmentsByInternalWorkOrder(id) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );
    return this.http.get(
      Constants.URL_BACKEND + "/attachments-internal-work-order/" + id,
      { headers: headers }
    );
  }
  getContactsByInternalWorkOrder(id) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );
    return this.http.get(
      Constants.URL_BACKEND + "/contacts-internal-work-order/" + id,
      { headers: headers }
    );
  }
  updateAttachmentsByInternalWorkOrder(listData, idInternalWorkOrder) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );
    return this.http.post(
      Constants.URL_BACKEND + "/attachments-internal-work-order/",
      { data: listData, idInternalWorkOrder: idInternalWorkOrder },
      { headers: headers }
    );
  }
  updateContactsByInternalWorkOrder(listData, idInternalWorkOrder) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );
    return this.http.post(
      Constants.URL_BACKEND + "/contacts-internal-work-order/",
      { data: listData, idInternalWorkOrder: idInternalWorkOrder },
      { headers: headers }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/system/services/work-order.service.ts